import * as React from 'react'
import { Select } from 'antd'
import { isObject } from 'formik'
import apiClient from 'services/api'
import { StyleHTMLAttributes } from 'react'
import fieldProps from './fieldProps'
import { getaxiosErrorMessage } from '../../utils'

const { Option } = Select

const isIrisResource = (value: object | string) => isObject(value) && value['@id']

export interface AsyncSelectProps {
  valueKey?: string
  useIris?: boolean
  value?: any
  parms?: any
  source: string
  onChange: any
  valueLabel?: string
  mode?: undefined | 'multiple'
  style?: StyleHTMLAttributes<any>
  placeholder?: string
  disabled?: boolean
  getLabel?: (item: any) => any
  getKey?: (item: any) => any
  loading?: boolean
  prependOption?: any
  useAxios?: boolean
  optionsFilter?: (options: any[]) => any[]
  className?: string
  sort?: (arg1: any, arg2: any) => void
  onSelected?: (value: any) => void
}

class AsyncSelect extends React.Component<AsyncSelectProps, any> {
  static defaultProps = {
    valueKey: '@id',
    useIris: true,
    useAxios: false,
  }

  constructor(props: AsyncSelectProps) {
    super(props)
    this.state = {
      data: props.useIris && isIrisResource(props.value) ? [props.value] : [],
      error: null,
      loading: true,
    }
  }

  componentDidMount() {
    this.refresh()
  }

  refresh() {
    const { parms, source, optionsFilter, sort } = this.props
    return apiClient
      .get(source, {
        params: {
          ...(parms || {}),
          pagination: false,
        },
      })
      .then(res => {
        const options = optionsFilter ? optionsFilter(res.data?.['hydra:member'] || res.data) : res.data?.['hydra:member'] || res.data
        const sortedOptions = options?.sort(sort)

        this.setState({ data: sortedOptions, error: null, loading: false });
      })
      .catch(e => {
        this.setState({ error: getaxiosErrorMessage(e), loading: false })
        // axiosErrorHandler(e)
      })
  }

  render() {
    const {
      value,
      onChange,
      valueKey = '@id',
      valueLabel = 'label',
      mode,
      style,
      placeholder,
      useIris = false,
      disabled = false,
      prependOption,
      getLabel,
      getKey,
      className,
      onSelected,
    } = this.props
    let currentValue = value
    if (useIris) {
      if (mode === 'multiple') {
        currentValue = currentValue?.map((v: any) => (isIrisResource(v) ? v[valueKey] : v))
      } else if (isIrisResource(currentValue)) {
        currentValue = currentValue['@id']
      }
    }

    if (this.state.error) {
      return <div className={'alert alert-danger'}>{this.state.error}</div>
    }

    const options = this.state.data.map((d: any) => {
      const id = getKey ? getKey(d) : d[valueKey]
      return (
        <Option value={id} key={d[valueKey]} item={d}>
          {getLabel ? getLabel(d) : d[valueLabel]}
        </Option>
      )
    })
    
    return (
      <Select
        className={className}
        showSearch
        style={style}
        placeholder={placeholder}
        allowClear
        value={currentValue}
        mode={mode}
        loading={this.state.loading}
        filterOption={(input, option: any) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onChange={(newValue) => {
          console.log("Selezionato:", newValue);
          if (onChange) onChange(newValue); 
          if (onSelected) onSelected(newValue);
        }}        
        disabled={disabled}
      >
        {prependOption}
        {options}
      </Select>
    )
  }
}

export default fieldProps(AsyncSelect)
